import { ResearchStudio } from './ResearchStudio'

// Standalone top-level "Timetable Studio" tab.
// Visibility: SG-Exec-Reports OR Reports admins (the exec-or-admin gate).
// The Studio previously lived inline at the bottom of the Research tab; it now
// has its own route (/timetable-studio) and is no longer shown on Research.
// The API side is gated with requireExecOrAdmin on every studio route; this
// client gate is UX only — the security boundary is the API.
export function TimetableStudioScreen({
  me,
}: {
  me: { isExec: boolean; isAdmin: boolean; upn?: string }
}) {
  const allowed = me.isExec || me.isAdmin

  if (!allowed) {
    return (
      <main className="app-main">
        <div className="placeholder">
          <strong>Timetable Studio — restricted</strong>
          <p>
            This workbench is limited to <code>SG-Exec-Reports</code> (and Reports
            admins). Ask Chris Flynn for access.
          </p>
        </div>
      </main>
    )
  }

  return (
    <main className="app-main">
      <ResearchStudio enabled={allowed} upn={me.upn} />
    </main>
  )
}
